<ion-content>
	<div class="quickLogger-logo">
		<ion-img src="./../../../../assets/icon/quickLogger-logo.png" alt="QuickLogger logo"></ion-img>
	</div>
	<div class="content">
		<div class="progress-bar">
			<div class="back-button" (click)="goBack()"><ion-icon class="icon-Arrow-Left"></ion-icon></div>
			<ul>
				<li class="current"><span class="outer-circle"></span></li>
				<li><span class="outer-circle"></span></li>
				<li><span class="outer-circle"></span></li>
				<li><span class="outer-circle"></span></li>
			</ul>
		</div>

		<div class="helper-text">{{ helperText }}</div>

		<div class="form">
			<form
				[formGroup]="registrationForm"
				role="form"
				(ngSubmit)="onSubmit(registrationForm.value)"
				autocomplete="off"
			>
				<ion-item>
					<ion-select
						formControlName="fieldFormControl"
						[interfaceOptions]="customDropdownOptions"
						[value]="connectionId"
						[placeholder]="'registration.form.placeholder.connection' | translate"
					>
						<ng-container *ngIf="connectionsList">
							<ion-select-option
								*ngFor="let connection of connectionsList"
								value="{{ connection.connectionId }}"
								>{{ connection.serverAlias }}</ion-select-option
							>
						</ng-container>
					</ion-select>
				</ion-item>
				<ion-item>
					<div (click)="goToConnectionManager()" class="connection-manager">
						{{ 'registration.buttons.connectionManager' | translate }}
					</div>
				</ion-item>
				<ion-item>
					<button type="submit" [ngClass]="{ disabled: !registrationForm.valid }">
						{{ 'registration.buttons.submit' | translate }}
					</button>
				</ion-item>
			</form>
		</div>
	</div>
	<div class="datamine-logo">
		<ion-img src="./../../../../assets/icon/datamine-logo.png" alt="Datamine logo"></ion-img>
	</div>
</ion-content>
